<script lang="ts" setup>
type SpotlightColor = 'blue' | 'yellow' | 'purple' | 'pink' | 'orange' | 'lime' | 'coral';

interface Props {
  // Colour of the blurred blob behind the card content.
  color?: SpotlightColor;
}

const props = withDefaults(defineProps<Props>(), {
  color: 'blue',
});

const spotlightColor = computed(() => {
  switch (props.color) {
    case 'blue': return 'bg-brand-blue';
    case 'yellow': return 'bg-brand-yellow';
    case 'purple': return 'bg-brand-purple';
    case 'pink': return 'bg-brand-pink';
    case 'orange': return 'bg-brand-orange';
    case 'lime': return 'bg-secondary';
    case 'coral': return 'bg-brand-coral';
    default: return 'bg-brand-blue';
  }
});
</script>

<template>
  <div class="bg-white rounded-4xl px-5 py-6 lg:px-8 lg:py-10 h-full relative overflow-hidden">
    <div class="relative z-10">
      <slot name="header" />
      <slot />
    </div>
    <div :class="spotlightColor" class="size-80 rounded-full blur-xl absolute -right-16 -bottom-16 opacity-60 z-0" />
  </div>
</template>
